import type { GameWithRelations } from "@/features/games/types";
import type { GameCurrentStats } from "@/features/games/api/getGameCurrentStats";

export type CompareGame = {
  game: GameWithRelations;
  stats: GameCurrentStats;
};

export type CompareChartType =
  | "ccu"
  | "followers"
  | "topsellers"
  | "wishlist"
  | "reviews"
  | "price"
  | "mlt"
  | "newtrending";

/** X-axis alignment mode for compare charts. */
export type CompareTimeMode = "calendar" | "since_release";

export const COMPARE_COLORS = [
  "#a4d007",
  "#66c0f4",
  "#e35e1c",
  "#ff2e9a",
  "#7c3aed",
] as const;

export const MAX_COMPARE_GAMES = 5;
export const MIN_COMPARE_GAMES = 2;

// Time-unit conversions used by the since-release re-basing math. Kept together
// so the seconds ↔ ms relationship is explicit (MS_PER_DAY = SECONDS_PER_DAY × 1000).
export const SECONDS_PER_DAY = 86_400;
export const MS_PER_DAY = 86_400_000;
